<app-leveltwo [pageId]="3">
    <div heading="General Info" class="General">
      <h3>{{'DisabledTaxRelief.PageTitle'|translate}}</h3>
      <h4>{{'DisabledTaxRelief.Prop110'|translate}}</h4>

      <p>{{'DisabledTaxRelief.Prop110text'|translate}}</p>
      <h5>{{'DisabledTaxRelief.WhoQualifies'|translate}}</h5>
      <p>{{'DisabledTaxRelief.WhoQualifiestext1'|translate}}</p>
      <p>{{'DisabledTaxRelief.WhoQualifiestext2'|translate}}</p>
      <p>{{'DisabledTaxRelief.WhoQualifiestext3'|translate}}</p>
      <p>{{'DisabledTaxRelief.WhoQualifiestext4'|translate}}</p>
      <p>{{'DisabledTaxRelief.WhoQualifiestext5'|translate}}</p>
      <h4>{{'DisabledTaxRelief.EligibilityRequirements'|translate}}</h4>
      <p>{{'DisabledTaxRelief.EligibilityRequirements1'|translate}}</p>
      <p>{{'DisabledTaxRelief.EligibilityRequirements2'|translate}}</p>
      <p>{{'DisabledTaxRelief.EligibilityRequirements3'|translate}}</p>
      <p>{{'DisabledTaxRelief.EligibilityRequirements4'|translate}}</p>
      <p>{{'DisabledTaxRelief.EligibilityRequirements5'|translate}}</p>


      <button type="button" class="btn btn-primary">{{'DisabledTaxRelief.Downloadbutton'|translate}}</button>


    </div>
    <!-- <tab heading="FAQ">FAQ</tab>
    <tab heading="Forms">Forms</tab> -->
</app-leveltwo>
